import MonthGridDesktop from './MonthGridDesktop';
import useInfiniteCalendar from '../useInfiniteCalendar';

/**
 * CalendarDesktop - Desktop view for calendar.
 * Shows calendar in a 7-column grid with square day cells.
 *
 * Month range, initial scroll-to-today positioning, and edge loading are handled by
 * useInfiniteCalendar. The element holding scrollRef is the single bounded scroll container.
 */
function CalendarDesktop({ calendarData, startMonth, endMonth, onStartMonthChange, onEndMonthChange, userId = null, calendarId = null }) {
  const { scrollRef, months, handleScroll } = useInfiniteCalendar({
    onStartMonthChange,
    onEndMonthChange,
  });

  return (
    <div className="flex h-full flex-col relative w-full">
      <div className="flex justify-center w-full h-full relative">
        <div className="w-full max-w-[1200px] h-full flex flex-col md:px-20">
          <div
            ref={scrollRef}
            onScroll={handleScroll}
            className="flex-1 overflow-y-auto"
            style={{ overflowAnchor: 'none' }}
          >
            {months.map((ms) => (
              <div id={`month-${ms}-${userId}`} key={ms}>
                <MonthGridDesktop monthString={ms} calendarData={calendarData} userId={userId} calendarId={calendarId} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CalendarDesktop;
